import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPostBySlug } from '../services/api';

function formatDate(s) {
  if (!s) return '';
  const d = new Date(s);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await fetchPostBySlug(slug);
        setPost(data);
      } catch (e) {
        setErr(e.message || 'Error');
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) return <div className="container mx-auto px-4 py-10">Loading…</div>;
  if (err) return <div className="container mx-auto px-4 py-10 text-red-600">{err}</div>;
  if (!post) return <div className="container mx-auto px-4 py-10">Post not found.</div>;

  return (
    <div className="container mx-auto px-4 py-10 max-w-3xl">
      <div className="mb-6">
        <Link to="/blog" className="text-slate-600 hover:text-slate-900">← Back to Blog</Link>
      </div>

      <article>
        <header className="mb-6">
          <time className="text-xs text-slate-500">{formatDate(post.published_at)}</time>
          <h1 className="mt-2 text-3xl font-semibold text-slate-900">{post.title}</h1>
        </header>

        {post.featured_image && (
          <img
            src={post.featured_image}
            alt={post.title}
            className="w-full h-auto rounded-xl border border-slate-200 mb-6"
          />
        )}

        {/* Render HTML from CMS safely (server should sanitize) */}
        <div
          className="prose prose-slate max-w-none"
          dangerouslySetInnerHTML={{ __html: post.content || '' }}
        />

        {/* Optional: meta info */}
        <div className="mt-10 text-sm text-slate-500">
          {post.seo_keywords && (
            <p><span className="font-semibold text-slate-700">Tags:</span> {post.seo_keywords}</p>
          )}
        </div>
      </article>
    </div>
  );
}
